import React from "react";
import { jsPDF } from "jspdf";
import { numberToIndianWords } from "./numberToIndianWords";

export const generateBillPDF = (x, csData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    // format: "a5",
    format: [180, 250],
  });

  doc.setDrawColor(0, 0, 0);
  doc.setFontSize(13);
  doc.setFont("times");
  if (csData.billType === "false") {
    doc.text("Estimate", 77, 42);
  } else {
    doc.text("Tax Invoice", 77, 42);
  }
  doc.setFontSize(10);
  doc.text("GST No : 27BBKPK5411K1ZI ", 5, 42);
  doc.line(5, 44, 175, 44);
  doc.setFont("times");
  // doc.text("GST-No-27BBKPK5411K1ZI", 100, 35);
  let y = 50; // Adjust starting Y position
  const columnWidth = 15; // Adjust column widths for A5
  const contentWidth = 120; // Adjust content width for A5
  let srNo = 1;
  let pGSrNo = 1;
  let pSSrNo = 1;
  let totalOldGoldAmount = 0;
  let totalOldNotGoldAmount = 0;
  const purchaseItems = x.filter((product) => product.billtype === "purchase");
  console.log(x, "x");
  if (csData) {
    doc.text(`Mobile - ${csData.tblCustomerDetails.mobile}`, 5, y);
    doc.text(
      `Name - ${csData.tblCustomerDetails.firstName} ${csData.tblCustomerDetails.lastName}`,
      5,
      y + 5
    );
    doc.text(
      `Address - ${csData.tblCustomerDetails.currAddStreet} ${csData.tblCustomerDetails.currAddTown} ${csData.tblCustomerDetails.currAddState} ${csData.tblCustomerDetails.currAddPinCode}`,
      5,
      y + 10
    );
    doc.text(`Invoice No - ${csData.invoiceNo}`, 125, y);
    doc.text(
      `Date - ${new Date(csData.createdOn).toLocaleDateString("en-GB")}`,
      125,
      y + 5
    );
    doc.text(
      `Email - ${
        csData.tblCustomerDetails.email.includes("@example.com")
          ? ""
          : csData.tblCustomerDetails.email
      }`,
      125,
      y + 10
    );
    doc.text(`Pan Card - ${csData.tblCustomerDetails.panNo}`, 5, y + 15);
    doc.text(`Gst No - ${csData.tblCustomerDetails.gstNo}`, 125, y + 15);
  }

  doc.line(5, y + 20, 175, y + 20);
  y = 75;
  doc.setFontSize(9);
  doc.text("No", 6, y);
  doc.text("Items", 12, y);
  doc.text("HSN", 65, y);
  doc.text("Pc/Pr", 75, y);
  doc.text("Purity", 85, y);
  doc.text("Grs.Wt", 95, y);
  doc.text("Net.Wt", 107, y);
  doc.text("Rate", 119, y);
  doc.text("Orn Amt", 130, y);
  doc.text("Labour", 145, y);
  doc.text("Price", 160, y);
  doc.line(5, y + 3, 175, y + 3);

  const maxPageHeight = doc.internal.pageSize.height - 20;
  y += 10;
  doc.setFontSize(9);
  let soldProducts = x.filter((product) => product.billtype !== "purchase");

  soldProducts.forEach((item) => {
    if (y + 8 > doc.internal.pageSize.height - 10) {
      doc.addPage();
      y = 10; // Reset Y position for the new page
    }

    doc.text(srNo.toString(), 6, y);
    const productName =
      item.productName && item.productName.length > 15
        ? item.productName.substring(0, 12) + "..."
        : item.productName;

    doc.text(productName ? productName : "-", 12, y);
    doc.setFontSize(7);
    doc.setFont("times", "bold");
    doc.text(
      item.hallmark_amt ? `Hallmark amt-${item.hallmark_amt}` : "",
      12,
      y + 3
    );
    doc.setFont("times", "normal");
    doc.setFontSize(9);
    doc.text(
      item.hsnCode && item.hsnCode !== "null" && item.hsnCode !== "undefined"
        ? item.hsnCode
        : "-",
      65,
      y
    );
    doc.setFontSize(7);
    doc.setFont("times", "bold");
    doc.text(item.huidCode ? `UID-${item.huidCode}` : "", 70, y + 3);
    doc.setFontSize(9);
    doc.setFont("times", "normal");
    doc.text(item.quantity !== "null" ? item.quantity : "-", 75, y);
    doc.text(item.purity ? item.purity : "-", 85, y);
    doc.text(item.grosswt ? item.grosswt : "-", 95, y);
    doc.text(item.netWt ? item.netWt : "-", 107, y);
    if (item.mrp !== 0 && item.mrp !== "" && item.mrp !== "0") {
      doc.text(`MRP -`, 119, y);
      doc.text(`${parseFloat(item.mrp).toFixed(2)}`, 130, y);
    } else {
      doc.text(item.rate ? item.rate : "-", 119, y);
      doc.text(
        parseFloat(
          (parseFloat(item.rate) / 10) * parseFloat(item.netWt)
        ).toFixed(2),
        130,
        y
      );
    }
    const price =
      item.billtype !== "purchase"
        ? ((parseFloat(item.price) * 100) / 103).toFixed(2)
        : parseFloat(item.price).toFixed(2);
    const makingCharges = [
      item.making_fixed_amt,
      item.making_fixed_wastage,
      item.making_per_gram,
      item.making_percentage,
    ];

    // Filter out null, empty, or zero making charges
    const validMakingCharges = makingCharges.filter(
      (charge) => charge !== null && parseInt(charge) !== 0
    );

    // Choose making charge(s) based on the number of valid charges
    let makingChargeText = "";
    if (validMakingCharges.length > 1) {
      makingChargeText = `${parseFloat(item.makingchrg).toFixed(0)}`;
    } else if (
      item.making_percentage !== null &&
      parseInt(item.making_percentage) !== 0
    ) {
      makingChargeText = `${parseFloat(item.making_percentage).toFixed(0)}%`;
    } else if (
      item.making_per_gram !== null &&
      parseInt(item.making_per_gram) !== 0
    ) {
      makingChargeText = `${parseFloat(item.making_per_gram).toFixed(0)}/Gm`;
    } else if (validMakingCharges.length === 1) {
      makingChargeText = `${parseFloat(validMakingCharges[0]).toFixed(0)}`;
    } else {
      makingChargeText = `${parseFloat(item.makingchrg).toFixed(0)}`;
    }

    // Add making charge to PDF
    doc.text(makingChargeText, 145, y);
    // doc.text("0.00", 115, y);
    doc.text(price, 160, y);
    srNo++;
    y += 8;
  });

  doc.line(5, y - 3, 175, y - 3);
  y += 10;
  doc.setFontSize(7);
  if (purchaseItems.length > 0) {
    doc.line(10, y - 4, 75, y - 4);
    y += 0;
    doc.text("Item", 11, y);
    doc.text("Inv No", 36, y);
    doc.text("Amount", 61, y);
    doc.line(10, y - 4, 10, y + 2);
    doc.line(35, y - 4, 35, y + 2);
    doc.line(60, y - 4, 60, y + 2);
    doc.line(75, y - 4, 75, y + 2);

    y += 4;
    doc.line(10, y - 3, 75, y - 3);

    purchaseItems.forEach((product) => {
      y += 4;
      doc.line(10, y - 6, 10, y + 2);
      doc.line(35, y - 6, 35, y + 2);
      doc.line(60, y - 6, 60, y + 2);
      doc.line(75, y - 6, 75, y + 2);
      doc.text(product.productName || "N/A", 11, y);
      // doc.text(parseFloat(product.netWt).toFixed(3) || "0", 41, y);
      doc.text(product.purchase_invoice_no || "0", 36, y);
      doc.text((parseFloat(product.price) * -1).toFixed(0) || "0", 61, y);
    });

    y += 5;
    doc.line(10, y - 3, 85, y - 3);
  }

  let paymentModes = csData.paymentMode ? csData.paymentMode.split(",") : [];
  doc.setFontSize(9);
  y += 10;
  doc.text(`Payment Mode`, 10, y);
  let yPaymentModes = y + 5;
  paymentModes.forEach((paymentMode) => {
    if (yPaymentModes > maxPageHeight - 10) {
      doc.addPage();
      yPaymentModes = 5;
    }
    const [mode, amount] = paymentMode.split(":");
    doc.text(`${mode}`, 10, yPaymentModes);
    doc.text(`${amount}`, 10 + columnWidth, yPaymentModes);
    yPaymentModes += 5;
  });

  let totalSaleAmount = soldProducts.reduce((total, product) => {
    return total + parseFloat((parseFloat(product.price) * 100) / 103 || 0);
  }, 0);

  let payableGst = parseFloat(totalSaleAmount) * 0.03;

  y += 10;
  if (csData.tblCustomerDetails.currAddState === "Maharashtra") {
    doc.text(`Sales Amount:`, 125, y);
    doc.text(`${parseFloat(totalSaleAmount).toFixed(2)}`, 155, y);
    doc.text(`R.O./Discount:`, 125, y + 5);
    doc.text(`${csData.offer}`, 155, y + 5);
    doc.text(`CGST 1.5%:`, 125, y + 10);
    doc.text(`${parseFloat(payableGst).toFixed(2) / 2}`, 155, y + 10);
    doc.text(`SGST 1.5%:`, 125, y + 15);
    doc.text(`${parseFloat(payableGst).toFixed(2) / 2}`, 155, y + 15);
  } else {
    doc.text(`Sales Amount:`, 125, y + 5);
    doc.text(`${parseFloat(totalSaleAmount).toFixed(2)}`, 155, y + 5);
    doc.text(`R.O./Discount:`, 125, y + 10);
    doc.text(`${csData.offer}`, 155, y + 10);
    doc.text(`IGST 3%:`, 125, y + 15);
    doc.text(`${parseFloat(payableGst).toFixed(2)}`, 155, y + 15);
  }

  doc.text(`Purchase Amount (-):`, 125, y + 20);
  doc.text(`${parseFloat(csData.purchaseAmt).toFixed(2)}`, 155, y + 20);
  doc.text(`Recieved Amount:`, 125, y + 25);
  doc.text(`${parseFloat(csData.receivedAmt).toFixed(2)}`, 155, y + 25);
  doc.text(`Balance Amount:`, 125, y + 30);
  doc.text(
    `${parseFloat(
      parseFloat(csData.price) - parseFloat(csData.receivedAmt)
    ).toFixed(2)}`,
    155,
    y + 30
  );
  doc.text(`Total:`, 125, y + 35);
  doc.text(`${parseFloat(csData.price).toFixed(2)}`, 155, y + 35);

  let totalAmountInWords = numberToIndianWords(
    parseFloat(csData.price).toFixed(0)
  );
  doc.text(`Total in Words: ${totalAmountInWords} Only`, 10, y + 40);

  let footerY = doc.internal.pageSize.height - 40;
  doc.setFontSize(9);
  // doc.text("Raja Bazar, P.O. Jatni-752050, Khordha (Odisha)", 10, footerY);
  // doc.text("Phone Number: 0674-2492089 ", 10, footerY + 4);
  // doc.text("Mobile / Whatsapp: +91 7978114496 ", 10, footerY + 8);
  doc.text("Customer Signature", 10, footerY);
  doc.text(`Bill By - ${csData.billedby} `, 60, footerY - 5);
  doc.text(`Salesman - ${csData.soldby} `, 60, footerY);
  doc.text("For S.K Khandre Jewellers", 135, footerY);

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};
